import { GetLocaleText } from '../I18n';

export const formatPrice = (price: string): string => {
	price = (+price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ');
	price = price.substring(0, price.length - 3);
	return price + ' ' + GetLocaleText('prices');
};
